<router-outlet></router-outlet>

<div #overlay class="version-mismatch-overlay" *ngIf="isMismatch$ | async" data-testid="campaign-shell-version-mismatch-overlay">
  <div class="version-mismatch-card" role="alertdialog" aria-labelledby="campaign-unavailable-title" data-testid="campaign-shell-version-mismatch-card">
    <div class="version-mismatch-icon" data-testid="campaign-shell-version-mismatch-icon">
      <span class="version-mismatch-icon-img" aria-hidden="true"></span>
    </div>
    <h2 id="campaign-unavailable-title" class="version-mismatch-title" data-testid="campaign-shell-version-mismatch-title">Campaigns are temporarily unavailable</h2>
    <p class="version-mismatch-message" data-testid="campaign-shell-version-mismatch-message">We are facing some infrastructure issue. Our team has been notified. Please check again after some time.</p>
    <p class="version-mismatch-hint" data-testid="campaign-shell-version-mismatch-hint">You can access other parts of the application from topbar if you want to.</p>
    <button type="button" class="version-mismatch-check-again" (click)="checkAgain()" [disabled]="isChecking$ | async" data-testid="campaign-shell-version-mismatch-check-again-btn">
      <i class="fa fa-refresh" [class.fa-spin]="isChecking$ | async" aria-hidden="true"></i>
      Check again
    </button>
  </div>
</div>
